function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useState } from 'react';
import { Button, Spinner, Typography } from 'seagull';
import ContactSupportButton from "../../ContactSupportButton";
import { useEventReporter } from "../../../event-reporter";
import { ErrorResponse } from "../../../infra/ErrorResponse";
import { useStore, useStoreActions } from "../../../store/store-context";
import { ErrorType } from "../VendorOnboardingModal.utils";
import styles from "./SavingStep.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var SavingState = /*#__PURE__*/function (SavingState) {
  SavingState["Idle"] = "idle";
  SavingState["Saving"] = "saving";
  SavingState["Error"] = "error";
  SavingState["Success"] = "success";
  return SavingState;
}(SavingState || {});
export function SavingStep(props) {
  const {
    vobData,
    onSavingSuccess,
    onErrorBackButton
  } = props;
  const userInfo = useStore(state => state.userInfo);
  const [savingState, setSavingState] = useState(SavingState.Idle);
  const [errorType, setErrorType] = useState();
  const [failureMsg, setFailureMsg] = useState('Something unexpected happened');
  const {
    api,
    setUserInfo,
    setAuthToken,
    updateUserClientData,
    fetchUserInfo
  } = useStoreActions();
  const {
    reportToHubspot,
    reportToAppcues
  } = useEventReporter();
  useEffect(() => {
    setSavingState(SavingState.Saving);
    reportToAppcues('form-success', 'onboarding-signed-up');
    reportToHubspot('onboarding_signed_up', _objectSpread({
      email: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email()
    }, vobData));
    saveVobData().then(() => fetchUserInfo()).then(() => {
      setSavingState(SavingState.Success);
      onSavingSuccess(true);
    }).catch(err => {
      const stripeError = new ErrorResponse(err).parseStripeError();
      if (stripeError) {
        setErrorType(ErrorType.Stripe);
        setFailureMsg(stripeError.message);
      } else {
        setErrorType(ErrorType.General);
      }
      setSavingState(SavingState.Error);
    });
  }, []);
  async function saveVobData() {
    // update user info
    const editUserDetailsRes = await api.auth.editUserDetails({
      phone: vobData.phone,
      name: vobData.name
    });
    setUserInfo((userInfo === null || userInfo === void 0 ? void 0 : userInfo.updateUserDetails(editUserDetailsRes)) || null);

    // update/create vendor business
    const businessData = {
      name: vobData.companyName,
      businessTypes: vobData.businessTypes,
      businessTypeOther: vobData.businessTypeOther || null,
      postalAddress: vobData.postalAddress
    };
    const hasUserBusiness = Boolean(userInfo === null || userInfo === void 0 ? void 0 : userInfo.business());
    if (hasUserBusiness) {
      await api.vendor.update(businessData);
    } else {
      const {
        authToken
      } = await api.vendor.create(businessData);
      if (authToken != null) {
        await setAuthToken(authToken);
      }
    }

    // update client data
    await updateUserClientData({
      'onboarding-num-clients': parseInt(vobData.numOfInvoices)
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [savingState === SavingState.Saving ? /*#__PURE__*/_jsx(SavingData, {}) : null, savingState === SavingState.Error ? /*#__PURE__*/_jsx(ErrorState, {
      onErrorBackButton: onErrorBackButton,
      failureMsg: failureMsg,
      errorType: errorType
    }) : null]
  });
}
function SavingData() {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.savingContainer,
    "data-testid": "vob-saving",
    children: [/*#__PURE__*/_jsx(Spinner, {}), /*#__PURE__*/_jsx(Typography, {
      children: "Setting up your account"
    })]
  });
}
function ErrorState(props) {
  const {
    onErrorBackButton,
    failureMsg,
    errorType
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.errorContainer,
    "data-testid": "vob-error",
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsx(Typography, {
        "data-testid": "vob-failure-reason",
        variant: "h4",
        children: failureMsg
      }), /*#__PURE__*/_jsxs(Typography, {
        skin: "secondary",
        children: ["Click", ' ', /*#__PURE__*/_jsx(Typography, {
          as: "span",
          weight: "bold",
          children: "Back"
        }), ' ', "to try again or ", /*#__PURE__*/_jsx(ContactSupportButton, {}), "."]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.footer,
      onClick: () => {
        onErrorBackButton(errorType);
      },
      children: /*#__PURE__*/_jsx(Button, {
        "data-testid": "vob-error-back-btn",
        children: "Back"
      })
    })]
  });
}